var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ snackbar: true, show: _vm.isShow, [_vm.type]: true },domProps:{"innerHTML":_vm._s(_vm.message)}})
}
var staticRenderFns = []

export { render, staticRenderFns }